import GroupOrderList from '~/pages/OrderList';

export default GroupOrderList;
